import script from "./ProjectExpenses.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectExpenses.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectExpenses.vue?vue&type=style&index=0&id=4087145a&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4087145a"]])

export default __exports__